// Renders a component for sharing a student video

import React from 'react';
import { observer } from 'mobx-react';

// Translation
import translate from '../../translate/Translate';

// Config
import { config } from '../../../config';

// Routes
import { routes } from '../../../routes';

// Components
import Copy from '../../common/Copy';

const ShareVideo = props => {
  // Get values from props
  const { AppStore, PlayerStore } = props.store;
  const { sharePassword, shareSid } = PlayerStore;
  const translation = AppStore.translation.ShareVideo;
  const shareUrl = `${config.domain}${routes.authenticate}/${shareSid}`;
    
  return (
    <React.Fragment>
      <ul>
        <li>
          {translation.context_1}
        </li>
        <li>
          {translation.context_2}
        </li>
        <li>
          {translation.context_3}
        </li>
      </ul>

      <ul className="form__fields">
        <li className="field--inline">
          <Copy
            defaultValue={shareUrl}
            id="video-share-url"
            label={translation.url}
          />
        </li>

        <li className="field--inline">
          <Copy
            defaultValue={sharePassword}
            id="video-share-pw"
            label={translation.password}
          />
        </li>
      </ul>
    </React.Fragment>
  );
};

export default ShareVideo;